import React from 'react';
import Api from '../components/Api';
import { gsap } from 'gsap'

import { useState, useEffect } from "react";



function Poke() {

    useEffect(() => {
         gsap.from('.pokedex', {duration: 1, y: -1000 ,rotate: 360})
    }, []);

    const pokedex = Api();

    const pokemon = pokedex.map(poke => (
        poke.name.toUpperCase()
    ))

    const [idPokemon, setIdPokemon] = useState(1);

    const next = () => {
        if (idPokemon < 898) {
            setIdPokemon(idPokemon + 1);
        }
    }

    const open = () => {
        var audio = document.getElementById('audio');
        audio.play();
        gsap.to('.pokebola', { duration: 1, scale: 0, rotate: 360 });
        gsap.to('.face-up', { duration: 1, y: -85 });
        gsap.to('.face-down', { duration: 1, y: 84 });

    }
    const screen = "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/" + idPokemon + ".png";
    return (
        <React.Fragment>
            <section>

                <div className='pokedex'>
                    <div className='pokebola'>
                        <div className='red'></div>
                        <div className='white'></div>
                        <div className='play' onClick={open}></div>
                    </div>
                    <div className='face-up'></div>
                    <div className='num'><p>{idPokemon}</p></div>
                    <div className='screen' onClick={() => { next() }}>
                        <img src={screen} alt='pokemon'></img>
                    </div>
                    <h1 className='pokemon'>{pokemon[idPokemon - 1]} </h1>
                    <div className='fondo-pokedex'></div>
                    <div className='face-down'></div>
                </div>
            </section>
        </React.Fragment>
    );
}
export default Poke;